<template>
<div style="display:inline">
  <b-dropdown right>
    <template v-slot:button-content>
      <img src="https://img.icons8.com/ios-glyphs/16/ffffff/sms.png" />
      SMS
    </template>
    <b-dropdown-item @click="composeAttempt()">Tried to reach you</b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="composeBlank()">Blank</b-dropdown-item>
  </b-dropdown>
  <b-modal ref="composer" title="Send SMS" ok-only :ok-title="sending ? 'Sending' : 'Send'" :ok-disabled="!message" :busy="sending" @ok="send">
    <b-form-textarea v-model="message" placeholder="Type message..." rows="5" :disabled="sending"></b-form-textarea>
    <small class="text-muted" v-if="message">{{message.length}} characters ({{Math.ceil(message.length / 160)}} messages)</small>
  </b-modal>
</div>
</template>
<script>
import $auth from '@/services/auth';
import $twilio from '@/services/twilio';
import {
  SendSMS
} from '@/gql/members/SMS.gql';

export default {
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      message: null,
      sending: false
    }
  },
  methods: {
    composeAttempt() {
      this.message = `Hi ${this.member.name}! \nI'm one of the Community Managers at C-Suite Circle - you recently joined our CEO network via LinkedIn. \nI tried to give you a call to welcome you to the network, but wasn't able to get through. I will try again tomorrow, although if you prefer you can schedule a time at https://calendly.com/csuitecircle/ceo-network-welcome-call. \nI look forward to connecting with you soon. \n${$auth.getUser().name}`;
      this.$refs.composer.show()
    },
    composeBlank() {
      this.message = '';
      this.$refs.composer.show()
    },
    async send(evt) {
      evt.preventDefault(); // Prevent from closing automatically
      this.sending = true;
      await this.$apollo.mutate({
        mutation: SendSMS,
        variables: {
          from: $twilio.number,
          to: this.member.phone,
          message: this.message
        }
      });
      this.sending = false;
      this.$refs.composer.hide()
      this.$apollo.queries.history.refetch();
    }
  }

}
</script>
